import { iamportCertifications, iamportFindCertifications } from "../api/auth";

// 본인인증 재시도 함수
async function attemptCertification(find?: boolean): Promise<{
  username: string;
  phoneNumber: string;
  birth: string[];
  gender: "MALE" | "FEMALE";
  existed: boolean;
  exited: boolean;
  userId?: number;
  nickname?: string;
  textId?: string;
  isAlreadyDoReferral: boolean;
}> {
  return new Promise((resolve, reject) => {
    if (!window.IMP) {
      return reject(new Error("아이엠포트 초기화 실패"));
    }

    window.IMP.certification(
      {
        merchant_uid: "merchant_" + new Date().getTime(),
        popup: false,
      },
      async (resp) => {
        if (resp.success) {
          try {
            const certFn = find
              ? iamportFindCertifications
              : iamportCertifications;
            const certResp = await certFn({
              impUid: resp.imp_uid,
              merchantUid: resp.merchant_uid,
            });

            const [birthYear, birthMonth, birthDate] =
              certResp.data.birthday.split("-");

            resolve({
              username: certResp.data.name,
              phoneNumber: certResp.data.phone,
              birth: [birthYear, birthMonth, birthDate],
              gender: certResp.data.gender === "male" ? "MALE" : "FEMALE",
              existed: certResp.isAlreadyExistUser,
              exited: certResp.isAlreadyExitUser,
              userId: certResp.userId,
              nickname: certResp.nickname,
              textId: certResp.textId,
              isAlreadyDoReferral: certResp.isAlreadyDoReferral,
            });
          } catch (e: any) {
            const msg = typeof e === "string" ? e : e.message;
            reject(new Error(msg));
          }
        } else {
          reject(new Error(resp.error_msg || "본인인증 실패"));
        }
      }
    );
  });
}

export async function certification(find?: boolean) {
  const maxRetries = 3;
  let lastError: Error = new Error("알 수 없는 오류");

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      console.log(`본인인증 시도 ${attempt}/${maxRetries}`);
      return await attemptCertification(find);
    } catch (error: any) {
      lastError = error;
      const msg = (typeof error === "string" ? error : error.message) as string;

      if (msg.indexOf("사용자") > -1) {
        // 사용자가 취소하면 바로 종료
        break;
      }
      console.warn(`본인인증 ${attempt}/${maxRetries} 실패:`, error.message);

      // 마지막 시도가 아니면 잠시 대기
      if (attempt < maxRetries) {
        console.log(`${attempt * 1000}ms 후 재시도...`);
        await new Promise((resolve) => setTimeout(resolve, attempt * 1000));
      }
    }
  }

  console.error("본인인증 최종 실패:", lastError.message);
  throw lastError;
}
